/*
 * Copyright 2025 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BaseSchemaGenerator } from "../BaseSchemaGenerator"

/**
 * Class that generates schema for number values
 */
export class NumberSchemaGenerator extends BaseSchemaGenerator {
    /**
     * Generates schema from number values.
     * @param {unknown} value Number value
     * @param {boolean} includeExample Whether to include example in schema (default: true)
     * @returns {Record<string, unknown>} Generated schema
     */
    public generateSchema(value: unknown, includeExample: boolean = true): Record<string, unknown> {
        if (typeof value !== "number") {
            return { type: "number" }
        }

        const schema: Record<string, unknown> = {
            type: Number.isInteger(value) ? "integer" : "number",
        }

        if (includeExample) {
            schema.example = value
        }

        return schema
    }
}
